import ResourceAudioPage from "@/components/ResourceAudioPage";
import { FEELINGS_AUDIO_URL } from "@/content";

export default function FeelingsPage() {
  return (
    <ResourceAudioPage
      title="Feelings"
      subtitle="A gentle guided audio to help you name, locate, and make sense of what's moving through you."
      label="Feelings · Guided Practice"
      src={FEELINGS_AUDIO_URL}
      testId="feelings-page"
    />
  );
}
